/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var WorkflowsIcon = createIcon("WorkflowsIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 2.25a9.72 9.72 0 016.894 2.856A9.72 9.72 0 0121.75 12a9.727 9.727 0 01-.985 4.275A3.191 3.191 0 0019 15.75a3.24 3.24 0 00-2.298.952A3.24 3.24 0 0015.75 19a3.243 3.243 0 00.521 1.766A9.667 9.667 0 0112 21.75a9.72 9.72 0 01-6.894-2.856A9.72 9.72 0 012.25 12a9.726 9.726 0 01.985-4.275A3.196 3.196 0 005 8.25a3.24 3.24 0 002.298-.952A3.24 3.24 0 008.25 5a3.243 3.243 0 00-.521-1.766A9.712 9.712 0 0112 2.25Z",
    stroke: _color,
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 22.25a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5Zm-14-14a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5Z",
    stroke: _color,
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 23a4 4 0 100-8 4 4 0 000 8ZM19 9a4 4 0 100-8 4 4 0 000 8Z",
    fill: _color
  }));
}, {
  "replaceColor": true
});